import {useQuery, type UseQueryResult} from '@tanstack/react-query'
import type {AxiosResponse} from 'axios'

import type {AssignedPolicyTypes} from 'interfaces'
import {PoliciesService} from 'services/api'

export const POLICY_ASSIGNMENT_QUERY_KEY = 'getPolicyAssignment'

export const usePolicyAssignmentQuery = (
  policyName: string,
): UseQueryResult<
  AxiosResponse<{
    message: string
    Items: AssignedPolicyTypes[]
  }>
> =>
  useQuery({
    queryKey: [POLICY_ASSIGNMENT_QUERY_KEY, policyName],
    queryFn: () => PoliciesService.getPolicyAssignment(policyName),
    enabled: Boolean(policyName),
    refetchOnWindowFocus: false,
    retry: false,
  })
